import { DialogHost, FieldNavHost, Icon, ToastHost } from '@orgazone/ui-web';

/**
 * Hôtes UI partagés du back-office (§24.1quater) — montés UNE fois près de la racine.
 *
 * Sans cet hôte, `confirm()` répond NON par sécurité et `alert()` n'écrit qu'en console : les actions
 * à confirmation deviennent muettes. C'est la raison d'être de ce fichier, pas une formalité de montage.
 *
 * ⚠️ La palette est écrite avec les noms CANONIQUES de la charte (`--paper`, `--ink-*`, `--rose-*`,
 * `--blue-*`, `--cta`), pas avec des alias locaux : elle suit donc le thème clair/sombre toute seule.
 * ⚠️ À MUTUALISER — la Console, le store et l'EDI écrivent chacun ce même mapping (le leur passe par
 * des alias d'app, d'où la divergence). Quatre copies d'une palette qui devrait être le DÉFAUT du
 * paquet : à porter dans `ui-web` sous forme de palette par défaut, l'injection restant possible pour
 * qui veut diverger (règle de 2, §24.3).
 */
export function BackofficeUiHost() {
  return (
    <>
      <ToastHost />
      <FieldNavHost />
      <DialogHost
        renderIcon={(name, size, color) => <Icon name={name} size={size} color={color} stroke={2} />}
        palette={{
          overlay: 'color-mix(in srgb, #000 55%, transparent)',
          card: 'var(--paper)',
          title: 'var(--ink-900)',
          message: 'var(--ink-500)',
          tile: {
            danger: { bg: 'var(--rose-bg)', fg: 'var(--rose-fg)' },
            err: { bg: 'var(--rose-bg)', fg: 'var(--rose-fg)' },
            warn: { bg: 'var(--amber-bg)', fg: 'var(--amber-fg)' },
            info: { bg: 'var(--blue-bg)', fg: 'var(--blue-fg)' },
          },
          cancel: { bg: 'transparent', fg: 'var(--ink-500)', border: 'var(--ink-200)' },
          action: {
            danger: { bg: 'var(--danger-ink)', fg: '#fff' },
            primary: { bg: 'var(--cta)', fg: 'var(--cta-ink)' },
          },
        }}
      />
    </>
  );
}
